import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { doucmentAnalyticAction } from "../asyncActions/documentActions";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import SubmitButton from "../UI/SubmitButton";
import Localozation from "../components/Localisation";

function DocumentAnalyticPage() {
    const today = dayjs();
    const dayOfWeek = today.day();
    const monday =
        dayOfWeek === 0 ? today.subtract(6, "day") : today.subtract(dayOfWeek - 1, "day");

    const [dateFrom, setDateFrom] = useState(monday);
    const [dateTo, setDateTo] = useState(today);

    const dispatch = useDispatch();
    const { analyticProduct } = useSelector((store) => store.documentProducts);

    const dateColumns = useMemo(() => {
        const dates = new Set();
        analyticProduct.forEach((item) => {
            Object.keys(item.per_day).forEach((date) => dates.add(date));
        });
        return Array.from(dates).sort();
    }, [analyticProduct]);

    const rows = useMemo(() => {
        return analyticProduct.map((item, index) => {
            const perDayFields = {};
            Object.entries(item.per_day).forEach(([date, perDay]) => {
                perDayFields[date] = {
                    count: perDay.quantity,
                    stock: perDay.current_stock,
                };
            });
            return {
                id: index,
                product: item.product,
                total_count: item.total_quantity,
                per_day: perDayFields,
            };
        });
    }, [analyticProduct]);

    const applyHandle = () => {
        dispatch(doucmentAnalyticAction({ dateFrom, dateTo }));
    };

    return (
        <Box
            sx={{
                padding: '10px',
                width: "95%",
                maxWidth: "1200px",
            }}
        >
            <Localozation>
                <Box
                    sx={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        marginBottom: 2,
                        justifyContent: "center",
                    }}
                >
                    <DatePicker
                        label="Date from"
                        format="YYYY-MM-DD"
                        value={dateFrom}
                        onChange={setDateFrom}
                    />
                    <DatePicker
                        label="Date to"
                        format="YYYY-MM-DD"
                        value={dateTo}
                        onChange={setDateTo}
                    />
                    <SubmitButton onClick={applyHandle}>APPLY</SubmitButton>
                </Box>
            </Localozation>

            <TableContainer
                component={Paper}
                sx={{
                    maxHeight: 600,
                    overflow: "auto",
                }}
            >
                <Table stickyHeader sx={{ width: "max-content", minWidth: "100%" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                rowSpan={2}
                                sx={{
                                    position: "sticky",
                                    left: 0,
                                    top: 0,
                                    zIndex: 3,
                                    backgroundColor: "white",
                                    fontWeight: "bold",
                                    minWidth: 150,
                                    whiteSpace: "nowrap",
                                    borderRight: "1px solid #ddd",
                                }}
                            >
                                Product
                            </TableCell>
                            {dateColumns.map((date) => (
                                <TableCell
                                    key={date}
                                    align="center"
                                    colSpan={2}
                                    sx={{
                                        position: "sticky",
                                        top: 0,
                                        backgroundColor: "white",
                                        fontWeight: "bold",
                                        whiteSpace: "nowrap",
                                        minWidth: 120,
                                        borderRight: "2px solid #ccc",
                                    }}
                                >
                                    {date}
                                </TableCell>
                            ))}
                            <TableCell
                                // rowSpan={2}
                                align="center"
                                sx={{
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "white",
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                    minWidth: 100,
                                    borderLeft: "2px solid #ccc",
                                    zIndex: 2,
                                }}
                            >
                                Total
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            {dateColumns.map((date) => (
                                <>
                                    <TableCell
                                        key={`${date}-stock`}
                                        align="center"
                                        sx={{
                                            position: "sticky",
                                            top: 48,
                                            backgroundColor: "white",
                                            fontWeight: "bold",
                                            whiteSpace: "nowrap",
                                            minWidth: 80,
                                            borderRight: "1px solid #eee",
                                        }}
                                    >
                                        Stock
                                    </TableCell>
                                    <TableCell
                                        key={`${date}-count`}
                                        align="center"
                                        sx={{
                                            position: "sticky",
                                            top: 48,
                                            backgroundColor: "white",
                                            fontWeight: "bold",
                                            whiteSpace: "nowrap",
                                            minWidth: 80,
                                            borderRight: "2px solid #ccc",
                                        }}
                                    >
                                        Count
                                    </TableCell>
                                </>
                            ))}
                            <TableCell
                                align="center"
                                sx={{
                                    position: "sticky",
                                    top: 48,
                                    backgroundColor: "white",
                                    fontWeight: "bold",
                                    minWidth: 100,
                                }}
                            >
                                Count
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell
                                    sx={{
                                        position: "sticky",
                                        left: 0,
                                        backgroundColor: "white",
                                        zIndex: 1,
                                        borderRight: "1px solid #ddd",
                                        whiteSpace: "nowrap",
                                        minWidth: 150,
                                    }}
                                >
                                    {row.product}
                                </TableCell>
                                {dateColumns.map((date) => (
                                    <>
                                        <TableCell
                                            key={`${row.id}-${date}-stock`}
                                            align="center"
                                            sx={{
                                                minWidth: 80,
                                                borderRight: "1px solid #eee",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {row.per_day[date]?.stock ?? 0}
                                        </TableCell>
                                        <TableCell
                                            key={`${row.id}-${date}-count`}
                                            align="center"
                                            sx={{
                                                minWidth: 80,
                                                borderRight: "2px solid #ccc",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {row.per_day[date]?.count ?? 0}
                                        </TableCell>
                                    </>
                                ))}
                                <TableCell
                                    align="center"
                                    sx={{
                                        minWidth: 100,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {row.total_count}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default DocumentAnalyticPage;
